import { ChildrenType } from "../@types";
import { AuthProvider } from "./contexts";

export function AppProvider({ children }: ChildrenType) {
    return <AuthProvider>{children}</AuthProvider>;
}
